import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { List } from 'immutable';


import { DomUtilService, EmptyValueService, JsonStoreService, PathUtilService, KeysStoreService } from '../shared/services';
import { JSONSchema } from '../shared/interfaces';


export class AddNewElementButtonComponent {

   path: Array<any>;
   schema: JSONSchema;

  constructor(public domUtilService: DomUtilService,
    public emptyValueService: EmptyValueService,
    public jsonStoreService: JsonStoreService,
    public pathUtilService: PathUtilService,
    public keyStoreService: KeysStoreService) { }

  addNewElement() {
    const itemSchema = this.schema.items;
    const emptyValue = this.emptyValueService.generateEmptyValue(itemSchema);
    const values: List<any> = this.jsonStoreService.getIn(this.path);
    const insertIndex = values ? values.size : 0;
    const insertPath = this.path.concat(insertIndex);
    this.jsonStoreService.addIn(insertPath, emptyValue);
    // focus on the new added element
    const insertPathString = this.pathUtilService.toPathString(insertPath);
    setTimeout(() => {
      this.domUtilService.focusAndSelectFirstEditableChildById(insertPathString);
    });
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'add-new-element-button',
  styles: ["div.button-container { display: inline-block; width: 100%; } .btn-new-field { font-size: 13px; font-weight: bold; text-shadow: 0 1px 0 #fff; opacity: 0.5; background: transparent; border: 0; bottom: -5px; left: -5px; padding: 0px; } .btn-new-field:hover { color: green !important; opacity: 0.6; } "],
  template: "<div [class.disabled]=\"schema.disabled\"  class=\"button-container\"> <button type=\"button\" class=\"btn-new-field\" (click)=\"addNewElement()\">Add new</button> </div>",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DomUtilService, },
{type: EmptyValueService, },
{type: JsonStoreService, },
{type: PathUtilService, },
{type: KeysStoreService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'path': [{ type: Input },],
'schema': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
